import type { DetrixEvent, DetrixSession } from '../../types';

export function shortUrl(url: string, max = 22): string {
  try {
    const u = new URL(url);
    const s = (u.pathname + u.search).replace(/^\//, '') || u.host;
    return s.length > max ? `${s.slice(0, max - 1)}…` : s;
  } catch {
    return url.length > max ? `${url.slice(0, max - 1)}…` : url;
  }
}

export function isEventError(ev: DetrixEvent): boolean {
  return ev.type === 'error' || ev.type === 'system.error';
}

export function isNetworkError(status: number, err?: unknown): boolean {
  if (err) return true;
  return status >= 400;
}

export function buildLandmarks(session: DetrixSession, tMin: number, tMax: number): number[] {
  const set = new Set<number>([tMin, tMax]);
  const add = (x: number) => {
    if (Number.isFinite(x) && x >= tMin && x <= tMax) set.add(Math.round(x * 1000) / 1000);
  };
  for (const s of session.steps ?? []) {
    add(s.timestampStart);
    add(s.timestampEnd);
  }
  for (const a of session.actions ?? []) add(a.timestamp);
  for (const n of session.network ?? []) {
    add(n.timestamp);
    add(n.timestamp + Math.max(n.timing.durationMs, 1));
  }
  for (const r of session.browserResources ?? []) {
    add(r.timestamp);
    add(r.timestamp + Math.max(r.timing.durationMs, 1));
  }
  for (const e of session.events ?? []) add(e.timestamp);
  return [...set].sort((a, b) => a - b);
}
